import { useEffect, useState } from 'react';
import { collection, query, where, orderBy, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';

export function useOrderBids(orderId) {
  const [bids, setBids]       = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!orderId) return;

    const q = query(
      collection(db, 'bids'),
      where('orderId', '==', orderId),
      orderBy('amount', 'asc')
    );

    const unsubscribe = onSnapshot(
      q,
      (snap) => {
        setBids(snap.docs.map(d => ({ id: d.id, ...d.data() })));
        setLoading(false);
      },
      (err) => { console.error('[useOrderBids] onSnapshot error:', err); setLoading(false); }
    );

    return unsubscribe;
  }, [orderId]);

  return { bids, loading };
}
